import React, { useState, useEffect } from "react";
import Navbar from "../../../components/Navbar";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import style from "./DashboardAgendamento.module.css";
import Input from "../../../components/Input";
import SubmitButton from "../../../components/Button";
import Axios from "axios";
import InputMask from "react-input-mask";
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import jsPDF from "jspdf";
import Logo from './logo.png'; // Importe o logo aqui
import Transportadora from './Transportadora.png'; // Importe o logo aqui
import QRCode from 'qrcode';


import { SnackbarProvider, useSnackbar } from "notistack";

const DashboardAgendamento = () => {
  const { enqueueSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const [isFormVisible, setIsFormVisible] = useState(false); // Novo estado para controle de visibilidade
  const toggleFormVisibility = () => setIsFormVisible(!isFormVisible); // Função para alternar a visibilidade

  const [historico, setHistorico] = useState([]); // Estado para armazenar os dados do histórico
  const [totalContainers, setTotalContainers] = useState(0);
  const [total40FeetContainers, setTotal40FeetContainers] = useState(0);
  const [total20FeetContainers, setTotal20FeetContainers] = useState(0);
  const [isLoading, setIsLoading] = useState(true); // Estado para o carregamento
  const [error, setError] = useState(null); // Estado para erros
  const [filtroCNPJ, setFiltroCNPJ] = useState(""); // Estado para armazenar o CNPJ filtrado
  const usuario = JSON.parse(localStorage.getItem("user_token")).id;

  // Filtra os dados com base no ID do usuário logado
  const dadosFiltrados = historico.filter((item) => item.CNPJ_TRANSP === usuario);

  // Função para mostrar alertas
  const showAlert = (message, variant) => {
    enqueueSnackbar(message, { variant: variant });
  };

    // Função para formatar a data
    const formatData = (isoString) => {
      const date = new Date(isoString);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${day}/${month}/${year} - ${hours}:${minutes}`;
    };

  const LOGO_BASE64 = "data:image/png;base64,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";

  const generatePDFAgendamento = (agendamento) => {
    const doc = new jsPDF();

    QRCode.toDataURL("https://maps.app.goo.gl/LZe44Ak8iWNG1JUD7" + agendamento.LOCAL_ENTREGA)
      .then((url) => {
        // Configurações gerais
        doc.setFont("helvetica", "normal");

        // Adicionar logotipo no canto superior esquerdo
        doc.addImage(LOGO_BASE64, "PNG", 15, 15, 40, 15);

        // Cabeçalho centralizado
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("JC7 TERMINAIS PORTUARIOS E", 111, 21, null, null, "center");
        doc.text("TRANSPORTES LTDA", 99, 28, null, null, "center");

        // Informações principais
        doc.setFont("helvetica", "normal");
        doc.setFontSize(12);
        doc.text("Minuta de Entrega de Contêiner", 99, 38, null, null, "center");

        // Linha
        doc.line(10, 40, 200, 40);

        doc.text(`Válida somente em:`, 105, 52);
        doc.text(`${agendamento.DATA_AGENDA ? formatData(agendamento.DATA_AGENDA) : "SEM AGENDAMENTO"}`, 105, 58);


        doc.setFontSize(10);
        doc.text("Rod. P. Manoel da Nobrega, N° 83103 - São Vicente / SP", 105, 65);

        // Bloco de informações do documento
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text(`ID do Documento: ${agendamento.ID_CARREGAMENTO}`, 10, 52);

        doc.setFont("helvetica", "normal");
        doc.setFontSize(10);
        doc.text(`Número de Contêiner: ${agendamento.NUMERO_CONTEINER}`, 10, 63);
        doc.text(`Tipo/Tamanho: ${agendamento.TIPO_CONTAINER}`, 10, 69);
        doc.text(`Quantidade: 1 unidade(s)`, 10, 75);

        doc.line(10, 92, 200, 92);

        doc.line(100, 40, 100, 140);

        // Bloco de informações do motorista e transportadora
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("MOTORISTA", 10, 100);

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        
        doc.text(`Motorista: ${agendamento.NOME_MOTORISTA}`, 10, 110);
        doc.text(`CPF: ${formatarCPF(agendamento.CPF_MOTORISTA)}`, 10, 115);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("TRANSPORTADORA", 105, 100);

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(`${agendamento.NOME_TRANSP}`, 105, 110);
        doc.text(`CNPJ: ${formatarCNPJ(agendamento.CNPJ_TRANSP)}`, 105, 115);

        // Rodapé
        doc.setFontSize(9);
        doc.text("A DEVOLUÇÃO DEVE SER FEITA SOMENTE NA DATA E HORÁRIO MENCIONADOS NESTA MINUTA.", 10, 155);

        // Linha
        doc.line(10, 160, 200, 160);

        // Bloco de carimbo
        doc.rect(10, 165, 90, 50);
        doc.text("Carimbo do Depot / Terminal:", 12, 170);

        // QR Code para ajuda
        doc.addImage(url, "PNG", 142, 260, 30, 30);
        doc.setFont("helvetica", "bold");
        doc.setFontSize(9);
        doc.text("Precisa de ajuda para chegar?", 10, 260);

        doc.setFont("helvetica", "normal");
        doc.text("Se tiver dúvidas sobre como chegar ao terminal, basta escanear o QR Code ao lado. Ele irá ", 10, 270);
        doc.text("direcioná-lo diretamente para o nosso local no Google Maps. Fácil e prático!", 10, 275);

        // Salvar PDF
        doc.save(`Minuta-${agendamento.NUMERO_CONTEINER}.pdf`);
      })
      .catch((err) => {
        console.error("Erro ao gerar QR Code: ", err);
      });
  };



  const generatePDF = (agendamento) => {
    const doc = new jsPDF();

    // Generate QR Code as base64 image
    QRCode.toDataURL(agendamento.NOME_MOTORISTA)
      .then((url) => {
        const logoWidth = 52; // Width of the logo
        const logoHeight = 20; // Height of the logo
        const qrSize = 25; // Size of the QR code
        const yOffset = 148; // Halfway down an A4 page

        const addContent = (offset) => {

          // Add the logo in the upper left corner
          doc.addImage(Transportadora, 'PNG', 10, 10 + offset, logoWidth, logoHeight);

          // Position the QR code next to the logo
          const qrX = 30 + logoWidth + 10; // X position for the QR code (right of the logo with some padding)
          doc.addImage(url, 'PNG', qrX, 10 + offset, qrSize, qrSize); // Adjusted to position QR code next to logo

          // Formatar CPF
          const cpfFormatado = formatarCPF(agendamento.CPF_MOTORISTA);
          const inscricaoEstadualFormatada = formatarInscricaoEstadual(agendamento.INSCRICAO_ESTADUAL);
          const cnpjFormatado = formatarCNPJ(agendamento.CNPJ_TRANSP);
          const placaCavaloFormatada = formatarPlaca(agendamento.PLACA_CAVALO);
          const placaCarretaFormatada = formatarPlaca(agendamento.PLACA_CARRETA);
          const placaCarreta2Formatada = formatarPlaca(agendamento.PLACA_CARRETA2);
          const placaCarreta3Formatada = formatarPlaca(agendamento.PLACA_CARRETA3);

          // Cabeçalho com informações da transportadora à direita
          doc.setFontSize(8);
          const transportadoraInfo = `${agendamento.NOME_REDUZIDO}\n ${agendamento.ENDERECO}\n ${agendamento.CIDADE_ESTADO} - ${agendamento.CEP}\n CNPJ: ${cnpjFormatado} - I.E.: ${inscricaoEstadualFormatada}`;
          let rightOffset = doc.internal.pageSize.width - 10; // Margem direita
          doc.text(transportadoraInfo, rightOffset, 20 + offset, { align: 'right', maxWidth: 190 });

          // Altera a fonte para negrito para o número ANTT
          doc.setFont('helvetica', 'bold');  // Muda a fonte para negrito
          doc.text(`\n ANTT CRNTRC N°: ${agendamento.ANTT}`, rightOffset, 30 + offset, { align: 'right', maxWidth: 190 });  // Supondo uma nova linha para ANTT

          // Adiciona o título centralizado
          doc.setFont('helvetica', 'bold');  // Define a fonte como Helvetica em negrito para o título
          doc.setFontSize(14);
          doc.text("ORDEM DE CARREGAMENTO", 105, 45 + offset, null, null, "center");

          // Define a fonte normal para o resto do texto
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9);

          // Adiciona informações do motorista com o nome em negrito
          doc.text("Motorista: ", 10, 55 + offset);
          let initialX = doc.getTextWidth("Motorista: "); // Largura do texto "Motorista: "

          // Configura o nome do motorista em negrito
          doc.setFont('helvetica', 'bold');
          doc.text(agendamento.NOME_MOTORISTA, 10 + initialX, 55 + offset); // Adiciona o nome do motorista em negrito

          // Continuação das informações do motorista em estilo normal
          doc.setFont('helvetica', 'normal');
          let additionalInfo = `  - CPF: ${cpfFormatado} - CNH: ${agendamento.CNH_MOTORISTA || "Não Encontrado"}`;
          doc.text(additionalInfo, 10 + initialX + doc.getTextWidth(agendamento.NOME_MOTORISTA), 55 + offset);

          // Adiciona informações das placas
          doc.setFontSize(9);
          let placaInfo = `PLACA CAVALO: ${placaCavaloFormatada} - PLACA CARRETA: ${placaCarretaFormatada} - PLACA CARRETA 2: ${placaCarreta2Formatada} - PLACA CARRETA 3: ${placaCarreta3Formatada}`;
          doc.text(placaInfo, 10, 60 + offset);

          // Adiciona informações das placas
          doc.setFontSize(9);
          placaInfo = `NAVIO: ${agendamento.NOME_NAVIO} - DI: ${agendamento.NUMERO_DOC} - PEDIDO: ${agendamento.PEDIDO_MIC} - DESTINO: ${placaCarreta2Formatada}`;
          doc.text(placaInfo, 10, 65 + offset);

          // Draw horizontal line below NAVIO information
          const lineWidth = doc.internal.pageSize.width - 20; // Line width
          doc.line(10, 70 + offset, lineWidth + 10, 70 + offset); // Position line just below the last text

          // Set font to bold for "CHECK LIST PRÉ CARREGAMENTO"
          doc.setFont('helvetica', 'bold');

          // Add centered bold text below the line
          const checklistY = 75 + offset; // Correctly define the variable in scope
          doc.text("CHECK LIST PRÉ CARREGAMENTO", 105, checklistY, null, null, "center");

          // Set font back to normal if additional text follows
          doc.setFont('helvetica', 'normal');

          // Column setup
          const column1StartX = 20;
          const column2StartX = 105;
          const startY = checklistY + 10;
          const lineSpacing = 5;

          // Column 1 items
          const column1Items = [
            "CNH Dentro da Validade",
            "Documento do Veículo - DUT e ANTT",
            "Extintor de Incêndio",
            "Vedação da Caçamba",
            "Limpeza da Caçamba",
            "Lona em Bom Estado",
            "Pneus e Estepe em Bom Estado"];

          // Column 2 items
          const column2Items = [
            "Traje - Calça, Camisa e Sapato Fechado",
            "Kit de EPI - Capacete, Óculos, Protetor de Ouvido, Máscara",
            "Freios Funcionando",
            "Para-Choque em Bom Estado",
            "Lanternas e Faróis Funcionando",
            "Curso MOPP Dentro da Validade"
          ];

          // Printing column 1 items
          doc.setFontSize(8);
          doc.setFont('helvetica', 'normal');
          let currentY = startY;
          column1Items.forEach(item => {
            doc.text(item, column1StartX, currentY, null, null, 'left');
            currentY += lineSpacing;
          });

          // Printing column 2 items
          currentY = startY;
          column2Items.forEach(item => {
            doc.text(item, column2StartX, currentY, null, null, 'left');
            currentY += lineSpacing;
          });

          // Additional Emergency Kits
          doc.setFont('helvetica', 'normal');
          currentY += 5; // Additional spacing to separate from columns
          const emergencyItems = [
            "Kit de Emergência - Ferramentas, Calços, Cones, Fita Zebrada e Suporte p/ Fita, Placa \"Perigo Afasta-se\"",
            "Kit de Emergência, Placas c/ o Número da ONU e Rótulos de Risco - Exclusivo p/ PRODUTO PERIGOSO."
          ];
          emergencyItems.forEach(item => {
            doc.text(item, 20, currentY, null, null, 'left');
            currentY += lineSpacing; // Slightly larger spacing for readability
          });

          // Confirmation text
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(8);
          const confirmationText = "O Motorista confirma que todas as informações no check list são verdadeiras.";
          doc.text(confirmationText, 80, currentY + 5, null, null, 'left');

          // Date text
          doc.setFontSize(9);
          doc.setFont('helvetica', 'normal');
          const date = new Date();
          const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
          const dateString = `SANTOS, ${date.toLocaleDateString('pt-BR', dateOptions)}.`;
          doc.text(dateString, 142, currentY + 13, null, null, 'left');

          // Adiciona o logotipo no canto inferior esquerdo
          const pageHeight = doc.internal.pageSize.height;
          doc.addImage(Transportadora, 'PNG', 10, 10, 52, 20); // Adjusts the logo to appear in the upper left corner

          // Place the logo just below the "SANTOS, DATAHOJE()"
          // Assuming you know the y-position after adding all your text
          const lastTextY = 110 + offset; // You'll adjust this manually to fit your document's layout
          const dateTextY = lastTextY + 13;
          doc.addImage(Logo, 'PNG', 10, dateTextY + 10, 28, 10);


          if (offset === 148) {  // Only draw the cut line for the second copy
            doc.setDrawColor(0);
            doc.setLineWidth(0.3);
            doc.setLineDash([2, 2], 0);
            doc.line(10, offset - 2, 200, offset - 2); // Draw dashed line at the beginning of the second section
          }

        }

        // First half of the page
        addContent(0);

        // Second half of the page
        addContent(148);

        // Salva o PDF
        doc.save(`Ordem-de-Carregamento-${agendamento.NOME_MOTORISTA}.pdf`);
      })
      .catch(err => {
        console.error('Error generating QR Code: ', err);
      });
  };

  const formatarCPF = (cpf) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  };

  const formatarPlaca = (placa) => {
    if (!placa) return "";
    // Insere um hífen após o terceiro caractere
    return placa.replace(/^(\w{3})(\w{4})$/, "$1-$2");
  };

  function formatarInscricaoEstadual(ie) {
    // Exemplo de padrão: 123.456.789.012
    return ie.replace(/(\d{3})(\d{3})(\d{3})(\d{3})/, '$1.$2.$3.$4');
  }

  const formatarCNPJ = (cnpj) => {
    return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
  };

  useEffect(() => {
    // Função para buscar os dados do histórico
    const fetchHistorico = async () => {
      try {
        const response = await fetch("https://portal.jc7transportes.com.br/api/historico-carregamento");
        if (!response.ok) {
          throw new Error("Erro ao buscar o histórico.");
        }
        const data = await response.json();
        setHistorico(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistorico();
  }, []);

  // Função para formatar CPF
  const formatCPF = (cpf) => {
    const onlyNumbers = cpf.replace(/\D/g, ""); // Remove caracteres não numéricos
    return onlyNumbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4"); // Formata o CPF
  };

  // Função para formatar a data
  const formatDateTime = (isoString) => {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}/${month}/${year} - ${hours}:${minutes}`;
  };

// Função para deletar carregamento no frontend
const deleteCarregamento = async (id) => {
  try {
    const response = await Axios.post(`https://portal.jc7transportes.com.br/api/carregamento/deletar`, {
      ID_CARREGAMENTO: id
    });
    if (response.status === 200) {
      enqueueSnackbar("Carregamento deletado com sucesso!", { variant: "success" });
      setHistorico((prev) => prev.filter((item) => item.ID_CARREGAMENTO !== id));
    } else {
      enqueueSnackbar("Erro ao deletar o carregamento.", { variant: "error" });
    }
  } catch (err) {
    enqueueSnackbar("Erro ao deletar o carregamento.", { variant: "error" });
    console.error(err);
  }
};

  return (
    <>
      <Navbar veiculos />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>

          <div className={style.nav}>
            <div className={style.active}>
              Dashboard
            </div>

         {/* <div className={style.navItem} onClick={() => navigate("/agendamento/agendamentopesagem")} >
              Agendamento
            </div> */}
          </div>

          <section className={style.cards}>

          </section>

          <table className={style.table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>Número do Contêiner</th>
                <th>Motorista</th>
                <th>CPF</th>
                <th>Tipo Fluxo</th>
                <th>Tipo de Contêiner</th>
                <th>Data Agendamento</th>
                <th>Data Desova</th>
                <th>PDF Agendamento</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {historico
                .filter((item) => item.CNPJ_TRANSP === usuario) // Aplica o filtro automático baseado no CNPJ_TRANSP
                .map((item, index) => (
                  <tr
                    key={item.ID_CARREGAMENTO}
                    className={item.DATA_DESOVA === null ? style.highlight : undefined} // Aplica a classe highlight se DATA_DESOVA for null
                  >
                    <td>{item.ID_CARREGAMENTO}</td>
                    <td>{item.NUMERO_CONTEINER}</td>
                    <td>{item.NOME_MOTORISTA}</td>
                    <td>{formatCPF(item.CPF_MOTORISTA)}</td>
                    <td>{item.TIPO_FLUXO}</td>
                    <td>{item.TIPO_CONTAINER}</td>
                    <td>{item.DATA_AGENDA ? formatDateTime(item.DATA_AGENDA) : "SEM AGENDAMENTO"}</td>
                    <td>{item.DATA_DESOVA ? formatDateTime(item.DATA_DESOVA) : "AGUARDANDO"}</td>
                    <td>
                      <button onClick={() => generatePDFAgendamento(item)}>PDF</button>
                    </td>
                    <td>
                      {item.DATA_DESOVA === null && (
                        <button className={style.deleteButton} onClick={() => deleteCarregamento(item.ID_CARREGAMENTO)}>
                          <i className="fas fa-trash"></i>
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

        </div>

      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <DashboardAgendamento />
    </SnackbarProvider>
  );
}
